export default "__VITE_ASSET__1687ef0b__"